import { c as _c } from "react/compiler-runtime";
import AustraliaFlag from "./au.svg";
import CanadaFlag from "./ca.svg";
import SwitzerlandFlag from "./ch.svg";
import GermanyFlag from "./de.svg";
import EuropeFlag from "./eu.svg";
import UnitedStatesFlag from "./us.svg";
import UnitedKingdomFlag from "./gb.svg";
import NewZealandFlag from "./nz.svg";
import WorldFlag from "./world.svg";
import Image from "next/image";
interface FlagProps {
  country: string;
  width?: number;
  height?: number;
  className?: string;
}
export const Flag = t0 => {
  const $ = _c(36);
  const {
    country,
    width: t1,
    height: t2,
    className
  } = t0;
  const width = t1 === undefined ? 24 : t1;
  const height = t2 === undefined ? 24 : t2;
  switch (country) {
    case "au":
      {
        let t3;
        if ($[0] !== className || $[1] !== height || $[2] !== width) {
          t3 = <Image src={AustraliaFlag} alt="Australia" width={width} height={height} className={className} />;
          $[0] = className;
          $[1] = height;
          $[2] = width;
          $[3] = t3;
        } else {
          t3 = $[3];
        }
        return t3;
      }
    case "ca":
      {
        let t3;
        if ($[4] !== className || $[5] !== height || $[6] !== width) {
          t3 = <Image src={CanadaFlag} alt="Canada" width={width} height={height} className={className} />;
          $[4] = className;
          $[5] = height;
          $[6] = width;
          $[7] = t3;
        } else {
          t3 = $[7];
        }
        return t3;
      }
    case "ch":
      {
        let t3;
        if ($[8] !== className || $[9] !== height || $[10] !== width) {
          t3 = <Image src={SwitzerlandFlag} alt="Switzerland" width={width} height={height} className={className} />;
          $[8] = className;
          $[9] = height;
          $[10] = width;
          $[11] = t3;
        } else {
          t3 = $[11];
        }
        return t3;
      }
    case "de":
      {
        let t3;
        if ($[12] !== className || $[13] !== height || $[14] !== width) {
          t3 = <Image src={GermanyFlag} alt="Germany" width={width} height={height} className={className} />;
          $[12] = className;
          $[13] = height;
          $[14] = width;
          $[15] = t3;
        } else {
          t3 = $[15];
        }
        return t3;
      }
    case "eu":
      {
        let t3;
        if ($[16] !== className || $[17] !== height || $[18] !== width) {
          t3 = <Image src={EuropeFlag} alt="Europe" width={width} height={height} className={className} />;
          $[16] = className;
          $[17] = height;
          $[18] = width;
          $[19] = t3;
        } else {
          t3 = $[19];
        }
        return t3;
      }
    case "gb":
      {
        let t3;
        if ($[20] !== className || $[21] !== height || $[22] !== width) {
          t3 = <Image src={UnitedKingdomFlag} alt="United Kingdom" width={width} height={height} className={className} />;
          $[20] = className;
          $[21] = height;
          $[22] = width;
          $[23] = t3;
        } else {
          t3 = $[23];
        }
        return t3;
      }
    case "us":
      {
        let t3;
        if ($[24] !== className || $[25] !== height || $[26] !== width) {
          t3 = <Image src={UnitedStatesFlag} alt="United States" width={width} height={height} className={className} />;
          $[24] = className;
          $[25] = height;
          $[26] = width;
          $[27] = t3;
        } else {
          t3 = $[27];
        }
        return t3;
      }
    case "nz":
      {
        let t3;
        if ($[28] !== className || $[29] !== height || $[30] !== width) {
          t3 = <Image src={NewZealandFlag} alt="New Zealand" width={width} height={height} className={className} />;
          $[28] = className;
          $[29] = height;
          $[30] = width;
          $[31] = t3;
        } else {
          t3 = $[31];
        }
        return t3;
      }
    case "global":
      {
        let t3;
        if ($[32] !== className || $[33] !== height || $[34] !== width) {
          t3 = <Image src={WorldFlag} alt="Global" width={width} height={height} className={className} />;
          $[32] = className;
          $[33] = height;
          $[34] = width;
          $[35] = t3;
        } else {
          t3 = $[35];
        }
        return t3;
      }
    default:
      {
        return null;
      }
  }
};